(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-included"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // use block-in-view buttons to show that the grid is scrollable
    const blocksInView = document.querySelectorAll('.block-in-view');
    const includedBlocks = document.querySelectorAll('.lp-included-grid .lp-included');
    const includedBlocksLength = includedBlocks.length;
    const lpIncludedGrid = document.querySelector('.lp-included-grid');
    const blocksInViewLength = blocksInView.length;

    const blockInView = (index) => {
      const offsetLeft = includedBlocks[index * 2].offsetWidth * index;

      console.log('offsetLeft', offsetLeft);
      lpIncludedGrid.scrollTo({
        left: offsetLeft,
        behavior: 'smooth',
      });
    };

    blocksInView.forEach((block, index) => {
      block.addEventListener('click', () => {
        blocksInView.forEach((b) => b.classList.remove('active'));
        block.classList.add('active');
        blockInView(index);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pn-compare-images"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const slider = document.querySelector('.image-comparison .slider');
    const beforeImage = document.querySelector('.image-comparison .before-image');
    const sliderLine = document.querySelector('.image-comparison .slider-line');
    const sliderIcon = document.querySelector('.image-comparison .slider-icon');

    slider?.addEventListener('input', (e) => {
      let sliderValue = e.target.value + '%';

      beforeImage.style.width = sliderValue;
      sliderLine.style.left = sliderValue;
      sliderIcon.style.left = sliderValue;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pn-influencer-collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const addInfluencersButton = document.getElementById('add-influencers');
    const influenceColour1 = document.getElementById('influencer-colour1');
    const influenceColour2 = document.getElementById('influencer-colour2');

    influenceColour1?.addEventListener('change', function () {
      const image1 = document.getElementById('influence-image1');
      const selectedOption = this.options[this.selectedIndex];
      image1.src = selectedOption.getAttribute('data-image');
    });

    influenceColour2?.addEventListener('change', function () {
      const image2 = document.getElementById('influence-image2');
      const selectedOption = this.options[this.selectedIndex];
      image2.src = selectedOption.getAttribute('data-image');
    });

    addInfluencersButton?.addEventListener('click', (e) => {
      e.target.disabled = true;
      const influenceColour1 = document.getElementById('influencer-colour1');
      const influenceColour2 = document.getElementById('influencer-colour2');
      // add all products + 2 chosen colors to cart
      const chosenProducts = [influenceColour1.value, influenceColour2.value];

      const allProducts = document.querySelectorAll('.product-class');
      allProducts.forEach((product) => {
        if (product.getAttribute('data-product') !== '4701265395771') {
          chosenProducts.push(product.getAttribute('data-variant'));
        }
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: chosenProducts.map((variant) => ({
            id: variant,
            quantity: 1,
          })),
        }),
      })
        .then((x) => x.json())
        .then((y) => {
          e.target.disabled = false;

          if (y.status == 422) {
            alert(y.message);
          } else {
            window.location.href = '/cart';
          }
        });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pn-influencer-collection2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const collectionLimitTitle = document.getElementById('collection-limit-title');
    const limitPrice = parseFloat(collectionLimitTitle.getAttribute('data-limit'));
    const addInfluencersButton2 = document.getElementById('add-influencers-2');
    let totalPriceInfluencers = 0;
    const influencerCheckies = document.querySelectorAll('.influencer-checkies');
    const totalPriceInfluencersDom = document.getElementById('totalPriceInfluencers');

    influencerCheckies.forEach((checkbox) => {
      checkbox.disabled = false;
      checkbox.checked = false;

      checkbox.addEventListener('change', (e) => {
        const price = parseFloat(e.target.getAttribute('data-price')) / 100;

        if (e.target.checked) {
          totalPriceInfluencers += price;
        } else {
          totalPriceInfluencers -= price;
        }

        if (
          totalPriceInfluencers === 0 ||
          totalPriceInfluencers === NaN ||
          totalPriceInfluencers === undefined ||
          totalPriceInfluencers > limitPrice
        ) {
          addInfluencersButton2.disabled = true;
        } else {
          addInfluencersButton2.disabled = false;
        }
        totalPriceInfluencersDom.innerText = `(€${totalPriceInfluencers.toFixed(2)})`;
      });
    });

    addInfluencersButton2?.addEventListener('click', async (e) => {
      e.target.disabled = true;
      // get all checked products
      // if a product has multiple variants, get the selected variant
      const chosenProducts = Array.from(document.querySelectorAll('.influencer-checkies:checked')).map((x) => {
        // check if the product has select inside its parent
        const select = x.parentElement.querySelector('select');
        if (select) {
          return select.value;
        } else {
          return x.getAttribute('data-variant');
        }
      });

      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: chosenProducts.map((variant) => ({
            id: variant,
            quantity: 1,
          })),
        }),
      })
        .then((x) => x.json())
        .then((y) => {
          e.target.disabled = false;

          if (y.status == 422) {
            alert(y.message);
          } else {
            window.location.href = '/cart';
          }
        });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pn-main-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (sessionStorage.getItem('openCartOnLoad')) {
      sessionStorage.removeItem('openCartOnLoad');
      document.getElementById('cart-icon-button').click();
    }
    const addtocardbuttons = document.querySelectorAll('.addtocardbutton');

    addtocardbuttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        const variantId = event.target.dataset.variant;
        event.target.disabled = true;
        event.target.querySelector('.button-loading').classList.remove('hidden');
        console.log('variant', variantId);

        const formData = {
          items: [
            {
              id: variantId,
              quantity: 1,
            },
          ],
        };
        const formDataJSON = JSON.stringify(formData);
        const url = '/cart/add.js';
        const headers = {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        };
        fetch(url, {
          method: 'POST',
          headers: headers,
          body: formDataJSON,
        })
          .then((response) => {
            if (response.ok) {
              return response.json();
            }
            throw new Error('Network response was not ok.');
          })
          .then((data) => {
            event.target.querySelector('.button-loading').classList.add('hidden');
            event.target.disabled = false;

            sessionStorage.setItem('openCartOnLoad', 'true');
            window.location.reload();
          })
          .catch((error) => {
            event.target.querySelector('.button-loading').classList.add('hidden');
            event.target.disabled = false;
            console.error('There was a problem with the fetch operation:', error);
          });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pn-seo-compare"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // use block-in-view buttons to show that the grid is scrollable
    const blocksInView = document.querySelectorAll('.block-in-view');
    const includedBlocks = document.querySelectorAll('.seo-compare .seo-compare-block');
    const includedBlocksLength = includedBlocks.length;
    const lpIncludedGrid = document.querySelector('.seo-compare');
    const blocksInViewLength = blocksInView.length;

    const blockInView = (index) => {
      const offsetLeft = includedBlocks[index * 2].offsetWidth * index;

      console.log('offsetLeft', offsetLeft);
      lpIncludedGrid.scrollTo({
        left: offsetLeft,
        behavior: 'smooth',
      });
    };

    blocksInView.forEach((block, index) => {
      block.addEventListener('click', () => {
        blocksInView.forEach((b) => b.classList.remove('active'));
        block.classList.add('active');
        blockInView(index);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pn-seo-videos"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const videos = document.querySelectorAll('.click-video');
    const buttons = document.querySelectorAll('.click-video + button');

    videos.forEach((video, index) => {
      video.addEventListener('click', () => {
        if (!video.paused) {
          video.pause();
          return;
        }
        videos.forEach((v, i) => {
          if (i !== index && !v.paused) {
            v.pause();
          }
        });
        video.play();
        buttons[index].style.display = 'none';
      });

      video.addEventListener('pause', () => {
        buttons[index].style.display = 'block';
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
